import { get, isArray, isFunction, set, sum, sumBy } from 'lodash'
import React, { isValidElement, useCallback, useEffect, useState } from 'react'
import { deleteIcon, plusIcon } from './icon'

import Col from '../col'
import Row from '../row'
import Table from '../table'
import Tooltip from '../tooltip'

import './index.less'

const { Column } = Table
const getWidth = (span) => 1000 / span

export default function ArrayInput({
  children,
  defaultValue,
  value,
  onChange,
  mode = 'list',
  gutter = 10,
  require = false,
  deleteTip = '',
  plusTip = '',
  addText = '添加',
}) {
  if (!isFunction(children)) {
    throw new Error('ArrayInput的children必须是函数')
  }

  const [_value, setValue] = useState(value || defaultValue)

  useEffect(() => {
    setValue(value)
  }, [value])

  const _onChange = useCallback((value) => {
    if (onChange) {
      onChange(value)
    } else {
      setValue(value)
    }
  }, [])

  let inValue = _value || []
  if (require && inValue.length === 0) {
    inValue = [{}]
  }

  const changeValue = (index, name, value) => {
    inValue[index] = {
      ...inValue[index],
      [name]: value,
    }
    _onChange([...inValue])
  }

  const onAdd = (index) => {
    if (index === undefined) {
      _onChange([...inValue, {}])
    } else {
      inValue.splice(index + 1, 0, {})
      _onChange([...inValue])
    }
  }

  const onDelete = (i) => {
    inValue.splice(i, 1)
    _onChange([...inValue])
  }

  if (mode === 'list') {
    return (
      <div className="tntd-array-input">
        {inValue.map((item, index) => {
          let fields = children(item, index)
          if (!isArray(fields)) {
            fields = get(fields, 'props.children', [])
          }
          return (
            <Row gutter={gutter} key={index} className="tntd-array-input-item">
              {fields.map((field, i) => {
                if (!isValidElement(field)) {
                  return field ? (
                    <Col span={4} key={i}>
                      {field}
                    </Col>
                  ) : (
                    ''
                  )
                }
                const { name, span = 4, onChange: fieldChange, ...other } = field?.props
                return (
                  <Col span={span} key={i}>
                    {React.cloneElement(field, {
                      value: item[name] || undefined,
                      onChange: (e) => {
                        fieldChange && fieldChange(e, index, changeValue)
                        const newValue = e.target ? e.target.value : e
                        changeValue(index, name, newValue)
                      },
                      ...other,
                    })}
                  </Col>
                )
              })}
              <Col span={24 - (sum(fields.map((f) => get(f, 'props.span', 4))) % 24)}>
                <span className="tntd-array-input-action">
                  {plusTip ? (
                    <Tooltip title={plusTip} placement="left">
                      <span className="mr10" onClick={() => onAdd(index)}>
                        {plusIcon}
                      </span>
                    </Tooltip>
                  ) : (
                    <span className="mr10" onClick={() => onAdd(index)}>
                      {plusIcon}
                    </span>
                  )}
                  {deleteTip ? (
                    <Tooltip title={deleteTip} placement="right">
                      <span onClick={() => onDelete(index)}>{deleteIcon}</span>
                    </Tooltip>
                  ) : (
                    <span onClick={() => onDelete(index)}>{deleteIcon}</span>
                  )}
                </span>
              </Col>
            </Row>
          )
        })}
        {inValue.length === 0 && <a onClick={() => onAdd()}>{addText}</a>}
      </div>
    )
  } else {
    let fields = children({}, 0)
    if (!isArray(fields)) {
      fields = get(fields, 'props.children', [])
    }
    const dataSource = inValue.map((value, index) => {
      const fields = children(value, index)
      const back = {}
      fields.forEach((field) => {
        const name = field?.props?.name
        name && set(back, name, field)
      })
      return back
    })
    return (
      <div className="tntd-array-input">
        <Table
          dataSource={dataSource}
          pagination={false}
          locale={{
            emptyText: <a onClick={() => onAdd()}>{addText}</a>,
          }}
        >
          {fields.map((field) => {
            const { name, span, title } = field?.props || {}
            return (
              <Column
                key={name}
                dataIndex={name}
                title={title}
                width={getWidth(span || 24 / (fields.length + 1))}
                render={(field, row, index) => {
                  if (!isValidElement(field)) {
                    return field
                  }
                  const { onChange: fieldChange } = field.props
                  return React.cloneElement(field, {
                    value: inValue[index][name] || undefined,
                    onChange: (e) => {
                      fieldChange && fieldChange(e, index, changeValue)
                      const newValue = e.target ? e.target.value : e
                      changeValue(index, name, newValue)
                    },
                  })
                }}
              ></Column>
            )
          })}
          <Column
            key="action"
            dataIndex="action"
            title="操作"
            width={getWidth(24 - (sumBy(fields, 'props.span') % 24))}
            render={(text, row, index) => {
              return (
                <span className="tntd-array-input-action">
                  {plusTip ? (
                    <Tooltip title={plusTip} placement="left">
                      <span className="mr10" onClick={() => onAdd(index)}>
                        {plusIcon}
                      </span>
                    </Tooltip>
                  ) : (
                    <span className="mr10" onClick={() => onAdd(index)}>
                      {plusIcon}
                    </span>
                  )}
                  {deleteTip ? (
                    <Tooltip title={deleteTip} placement="right">
                      <span onClick={() => onDelete(index)}>{deleteIcon}</span>
                    </Tooltip>
                  ) : (
                    <span onClick={() => onDelete(index)}>{deleteIcon}</span>
                  )}
                </span>
              )
            }}
          ></Column>
        </Table>
      </div>
    )
  }
}
